import { useEffect, useState } from 'react';
import { Button, cn } from '@divlab/divanui';

import useMedias from '@Hooks/useMedias';
import { useDeps } from '@Contexts/DI';
import useTranslation from '@Queries/useTranslation';
import CardInView from '@Components/CardInView';
import ProductCard from '@LandingComponents/ProductCard';
import CatalogGallery from './elems/CatalogGallery';
import Link from '@Navigation/Link';
import styles from './Catalog.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { ProductData } from '@Types/Product';

interface CatalogProps extends HTMLAttributes<HTMLDivElement> {
  products: ProductData[];
}

const Catalog: FC<CatalogProps> = (props) => {
  const { className, products, ...restProps } = props;
  const [columns, setColumns] = useState(4);
  const [rows, setRows] = useState(2);
  const { isDesktop, isMobileM, isOnlyDesktop, isMobileXXS } = useMedias();
  const { analytics } = useDeps();
  const { t } = useTranslation();
  const title = t('catalog.title');
  const description = t('catalog.description');
  const button = t('see-all-products');

  useEffect(() => {
    if (isOnlyDesktop) setColumns(4);
    if (isDesktop) setColumns(3);
    if (isMobileM) setColumns(2);
    if (isMobileXXS) setColumns(1);
    setRows(isMobileXXS ? 1 : 2);
  }, [isDesktop, isMobileM, isOnlyDesktop, isMobileXXS]);

  const handleClick = () => {
    analytics.dispatchEvent('catalog.open', {
      action: 'show',
      label: 'landingCategoryItems',
      secondaryLabel: 'Pick and Pair Готовые решения список',
      targetPathname: '/category/promo-pick-and-pair',
    });
  };

  return (
    <div className={cn(styles.wrapper, className)} {...restProps}>
      <div className={styles.title}>{title}</div>
      <div className={styles.descriptionWrapper}>
        <span className={styles.description}>{description}</span>
      </div>

      <CatalogGallery
        className={styles.gallery}
        itemsCountInSlide={columns * rows}
        grid={[columns, rows]}
      >
        {products.map((product, index) => (
          <CardInView
            key={product.id}
            listTitle='Pick and Pair Готовые решения список'
            position={index}
            card={product}
            cardType='product'
            id={product.id}
            targetPathname={product.link}
          >
            <ProductCard product={product} needHoverZoom />
          </CardInView>
        ))}
      </CatalogGallery>

      <Link className={styles.link} to='/category/promo-pick-and-pair' onClick={handleClick}>
        <Button className={styles.button}>{button}</Button>
      </Link>

      <div className={styles.separator} />
    </div>
  );
};

export default Catalog;
